module.exports = __webpack_public_path__ + "5a39a79e3ae5802745135a5b4cc147c0.png";